module.exports = __webpack_public_path__ + "a93f00b023eea1172d78745e74f55ab8.png";